// import React, { useState } from "react";
// import { addDoc, collection, serverTimestamp } from "firebase/firestore";
// import {
//   FaPhoneAlt,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaWhatsapp,
//   FaClock,
//   FaCheckCircle,
// } from "react-icons/fa";

// import { db } from "../../firebase/firebase";

// import "./Contact.css";

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     fullName: "",
//     company: "",
//     email: "",
//     phone: "",
//     whatsapp: "",
//     city: "",
//     state: "",
//     sport: "",
//     projectType: "",
//     dimensions: "",
//     area: "",
//     surface: "",
//     budget: "",
//     timeline: "",
//     message: "",
//   });

//   const [submitting, setSubmitting] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [error, setError] = useState("");

//   // ==========================================
//   // HANDLE INPUT
//   // ==========================================

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((previous) => ({
//       ...previous,
//       [name]: value,
//     }));
//   };

//   // ==========================================
//   // SUBMIT QUOTE
//   // ==========================================

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setError("");
//     setSuccess(false);

//     // Basic validation
//     if (!formData.fullName.trim()) {
//       setError("Please enter your full name.");
//       return;
//     }

//     if (!formData.email.trim()) {
//       setError("Please enter your email address.");
//       return;
//     }

//     if (!formData.phone.trim()) {
//       setError("Please enter your phone number.");
//       return;
//     }

//     if (!formData.city.trim()) {
//       setError("Please enter your city.");
//       return;
//     }

//     if (!formData.sport) {
//       setError("Please select your sport / facility.");
//       return;
//     }

//     if (!formData.message.trim()) {
//       setError("Please describe your project requirements.");
//       return;
//     }

//     try {
//       setSubmitting(true);

//       await addDoc(collection(db, "quoteRequests"), {
//         ...formData,

//         status: "New",

//         source: "Website",

//         createdAt: serverTimestamp(),

//         updatedAt: serverTimestamp(),
//       });

//       setSuccess(true);

//       setFormData({
//         fullName: "",
//         company: "",
//         email: "",
//         phone: "",
//         whatsapp: "",
//         city: "",
//         state: "",
//         sport: "",
//         projectType: "",
//         dimensions: "",
//         area: "",
//         surface: "",
//         budget: "",
//         timeline: "",
//         message: "",
//       });
//     } catch (submitError) {
//       console.error("Error submitting quote request:", submitError);

//       setError("Unable to submit your request. Please try again.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <main className="contact-page">
//       {/* ==========================================
//           HERO
//       ========================================== */}

//       <section className="contact-hero">
//         <div className="contact-hero-overlay"></div>

//         <div className="contact-hero-content">
//           <span className="contact-badge">GET IN TOUCH</span>

//           <h1>
//             Let's Build Your
//             <span> Sports Facility</span>
//           </h1>

//           <p>
//             Tell us about your project and our team will get back to you with
//             the right solution for your sports facility.
//           </p>
//         </div>
//       </section>

//       {/* ==========================================
//           CONTACT INFORMATION + FORM
//       ========================================== */}

//       <section className="quote-section">
//         <div className="quote-container">
//           {/* ========================================
//               LEFT SIDE
//           ======================================== */}

//           <div className="quote-info">
//             <span className="section-label">GET A FREE QUOTE</span>

//             <h2>
//               Tell Us About
//               <span> Your Project</span>
//             </h2>

//             <p className="quote-intro">
//               Whether you are planning a new sports facility, renovating an
//               existing court, or looking for premium sports flooring, our team
//               is ready to help.
//             </p>

//             {/* CONTACT CARDS */}

//             <div className="contact-info-list">
//               <div className="contact-info-card">
//                 <div className="contact-info-icon">
//                   <FaPhoneAlt />
//                 </div>

//                 <div>
//                   <small>Call Us</small>

//                   <a href="tel:+919533634708">+91 95336 34708</a>
//                 </div>
//               </div>

//               <div className="contact-info-card">
//                 <div className="contact-info-icon">
//                   <FaWhatsapp />
//                 </div>

//                 <div>
//                   <small>WhatsApp</small>

//                   <a
//                     href="https://wa.me/919533634708"
//                     target="_blank"
//                     rel="noreferrer"
//                   >
//                     Chat With Us
//                   </a>
//                 </div>
//               </div>

//               <div className="contact-info-card">
//                 <div className="contact-info-icon">
//                   <FaEnvelope />
//                 </div>

//                 <div>
//                   <small>Email</small>

//                   <a href="mailto:info@qualitysportssurface.com">
//                     info@qualitysportssurface.com
//                   </a>
//                 </div>
//               </div>

//               <div className="contact-info-card">
//                 <div className="contact-info-icon">
//                   <FaMapMarkerAlt />
//                 </div>

//                 <div>
//                   <small>Location</small>

//                   <span>India</span>
//                 </div>
//               </div>

//               <div className="contact-info-card">
//                 <div className="contact-info-icon">
//                   <FaClock />
//                 </div>

//                 <div>
//                   <small>Working Hours</small>

//                   <span>Monday - Saturday</span>

//                   <span>9:00 AM - 6:00 PM</span>
//                 </div>
//               </div>
//             </div>

//             {/* TRUST MESSAGE */}

//             <div className="quote-trust">
//               <FaCheckCircle />

//               <div>
//                 <strong>No obligation quote</strong>

//                 <p>
//                   Our team will understand your requirements before recommending
//                   the right solution.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* ========================================
//               RIGHT SIDE FORM
//           ======================================== */}

//           <div className="quote-form-wrapper">
//             <div className="quote-form-header">
//               <h3>Request A Free Quote</h3>

//               <p>Fill in your project details below.</p>
//             </div>

//             {/* SUCCESS */}

//             {success && (
//               <div className="quote-success">
//                 <FaCheckCircle />

//                 <div>
//                   <strong>Request Submitted Successfully!</strong>

//                   <p>
//                     Thank you for contacting us. Our team will contact you
//                     shortly.
//                   </p>
//                 </div>
//               </div>
//             )}

//             {/* ERROR */}

//             {error && <div className="quote-error">{error}</div>}

//             <form className="quote-form" onSubmit={handleSubmit}>
//               {/* ==================================
//                   CUSTOMER INFORMATION
//               ================================== */}

//               <div className="form-section-title">Customer Information</div>

//               <div className="form-grid">
//                 <div className="form-group">
//                   <label>Full Name *</label>

//                   <input
//                     type="text"
//                     name="fullName"
//                     placeholder="Enter your full name"
//                     value={formData.fullName}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Company / Organization</label>

//                   <input
//                     type="text"
//                     name="company"
//                     placeholder="Company name"
//                     value={formData.company}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Email Address *</label>

//                   <input
//                     type="email"
//                     name="email"
//                     placeholder="your@email.com"
//                     value={formData.email}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Phone Number *</label>

//                   <input
//                     type="tel"
//                     name="phone"
//                     placeholder="+91 XXXXX XXXXX"
//                     value={formData.phone}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>WhatsApp Number</label>

//                   <input
//                     type="tel"
//                     name="whatsapp"
//                     placeholder="WhatsApp number"
//                     value={formData.whatsapp}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>City *</label>

//                   <input
//                     type="text"
//                     name="city"
//                     placeholder="Your city"
//                     value={formData.city}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>State</label>

//                   <input
//                     type="text"
//                     name="state"
//                     placeholder="Your state"
//                     value={formData.state}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* ==================================
//                   PROJECT INFORMATION
//               ================================== */}

//               <div className="form-section-title">Project Information</div>

//               <div className="form-grid">
//                 <div className="form-group">
//                   <label>Sport / Facility *</label>

//                   <select
//                     name="sport"
//                     value={formData.sport}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select Sport / Facility</option>

//                     <option value="Basketball">Basketball Court</option>

//                     <option value="Tennis">Tennis Court</option>

//                     <option value="Football">Football Field</option>

//                     <option value="Pickleball">Pickleball Court</option>

//                     <option value="Badminton">Badminton Court</option>

//                     <option value="Volleyball">Volleyball Court</option>

//                     <option value="Cricket">Cricket / Box Cricket</option>

//                     <option value="Squash">Squash Court</option>

//                     <option value="Running Track">Running Track</option>

//                     <option value="Synthetic Turf">Synthetic Turf</option>

//                     <option value="EPDM Flooring">EPDM Flooring</option>

//                     <option value="Multi Purpose">
//                       Multi-Purpose Facility
//                     </option>

//                     <option value="Other">Other</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label>Project Type</label>

//                   <select
//                     name="projectType"
//                     value={formData.projectType}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select Project Type</option>

//                     <option value="New Construction">New Construction</option>

//                     <option value="Renovation">Renovation</option>

//                     <option value="Resurfacing">Resurfacing</option>

//                     <option value="Maintenance">Maintenance</option>

//                     <option value="Other">Other</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label>Dimensions</label>

//                   <input
//                     type="text"
//                     name="dimensions"
//                     placeholder="Example: 100 ft × 50 ft"
//                     value={formData.dimensions}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Approximate Area</label>

//                   <input
//                     type="text"
//                     name="area"
//                     placeholder="Example: 5000 sq.ft"
//                     value={formData.area}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="form-group">
//                   <label>Surface / Flooring</label>

//                   <select
//                     name="surface"
//                     value={formData.surface}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select Surface</option>

//                     <option value="Acrylic">Acrylic</option>

//                     <option value="PU">PU</option>

//                     <option value="EPDM">EPDM</option>

//                     <option value="Synthetic Turf">Synthetic Turf</option>

//                     <option value="Rubber">Rubber</option>

//                     <option value="Other">Other</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label>Budget Range</label>

//                   <select
//                     name="budget"
//                     value={formData.budget}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select Budget</option>

//                     <option value="Below 5 Lakh">Below ₹5 Lakh</option>

//                     <option value="5 - 10 Lakh">₹5 - ₹10 Lakh</option>

//                     <option value="10 - 25 Lakh">₹10 - ₹25 Lakh</option>

//                     <option value="25 - 50 Lakh">₹25 - ₹50 Lakh</option>

//                     <option value="50 Lakh+">₹50 Lakh+</option>

//                     <option value="Not Decided">Not Decided</option>
//                   </select>
//                 </div>

//                 <div className="form-group">
//                   <label>Expected Timeline</label>

//                   <select
//                     name="timeline"
//                     value={formData.timeline}
//                     onChange={handleChange}
//                   >
//                     <option value="">Select Timeline</option>

//                     <option value="Immediately">Immediately</option>

//                     <option value="Within 1 Month">Within 1 Month</option>

//                     <option value="1 - 3 Months">1 - 3 Months</option>

//                     <option value="3 - 6 Months">3 - 6 Months</option>

//                     <option value="6+ Months">6+ Months</option>
//                   </select>
//                 </div>
//               </div>

//               {/* ==================================
//                   MESSAGE
//               ================================== */}

//               <div className="form-section-title">Project Requirements</div>

//               <div className="form-group full-width">
//                 <label>Tell Us About Your Project *</label>

//                 <textarea
//                   name="message"
//                   rows="6"
//                   placeholder="Describe your project, requirements, location, preferred materials, or anything else we should know..."
//                   value={formData.message}
//                   onChange={handleChange}
//                 />
//               </div>

//               {/* ==================================
//                   SUBMIT
//               ================================== */}

//               <button
//                 type="submit"
//                 className="quote-submit-btn"
//                 disabled={submitting}
//               >
//                 {submitting ? "Submitting Request..." : "Submit Quote Request"}
//               </button>

//               <p className="form-note">
//                 By submitting this form, you agree that our team may contact you
//                 regarding your project enquiry.
//               </p>
//             </form>
//           </div>
//         </div>
//       </section>
//     </main>
//   );
// };

// export default Contact;

import React, { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaClock,
  FaCheckCircle,
} from "react-icons/fa";

import { db } from "../../firebase/firebase";

import "./Contact.css";

const initialFormData = {
  fullName: "",
  company: "",
  email: "",
  phone: "",
  whatsapp: "",
  city: "",
  state: "",
  sport: "",
  projectType: "",
  dimensions: "",
  area: "",
  surface: "",
  budget: "",
  timeline: "",
  message: "",
};

const Contact = () => {
  const [formData, setFormData] = useState(initialFormData);

  const [errors, setErrors] = useState({});

  const [submitting, setSubmitting] = useState(false);

  const [success, setSuccess] = useState(false);

  const [error, setError] = useState("");

  // ==========================================
  // PHONE VALIDATION
  // ==========================================

  const validateIndianPhone = (phone) => {
    return /^[6-9]\d{9}$/.test(phone);
  };

  // ==========================================
  // HANDLE INPUT
  // ==========================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    // ==========================================
    // PHONE / WHATSAPP LIVE VALIDATION
    // ==========================================

    if (name === "phone" || name === "whatsapp") {
      // Only allow numbers
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);

      setFormData((previous) => ({
        ...previous,
        [name]: digitsOnly,
      }));

      // Clear general error
      setError("");

      // ==========================================
      // LIVE VALIDATION
      // ==========================================

      if (digitsOnly.length === 0) {
        setErrors((previous) => ({
          ...previous,
          [name]: "",
        }));

        return;
      }

      // First digit must be 6, 7, 8 or 9
      if (!/^[6-9]/.test(digitsOnly)) {
        setErrors((previous) => ({
          ...previous,
          [name]: "Invalid mobile number. Number must start with 6, 7, 8 or 9.",
        }));

        return;
      }

      // Check length while typing
      if (digitsOnly.length < 10) {
        setErrors((previous) => ({
          ...previous,
          [name]: `Enter ${
            10 - digitsOnly.length
          } more digit${10 - digitsOnly.length === 1 ? "" : "s"}.`,
        }));

        return;
      }

      // Exactly 10 digits = valid
      if (digitsOnly.length === 10) {
        setErrors((previous) => ({
          ...previous,
          [name]: "",
        }));

        return;
      }
    }

    // ==========================================
    // OTHER INPUTS
    // ==========================================

    setFormData((previous) => ({
      ...previous,
      [name]: value,
    }));

    setErrors((previous) => ({
      ...previous,
      [name]: "",
    }));

    setError("");

    if (success) {
      setSuccess(false);
    }
  };

  // ==========================================
  // VALIDATE FORM
  // ==========================================

  const validateForm = () => {
    const newErrors = {};

    // ------------------------------------------
    // FULL NAME
    // ------------------------------------------

    if (!formData.fullName.trim()) {
      newErrors.fullName = "Please enter your full name.";
    } else if (formData.fullName.trim().length < 2) {
      newErrors.fullName = "Please enter a valid name.";
    }

    // ------------------------------------------
    // EMAIL
    // ------------------------------------------

    if (!formData.email.trim()) {
      newErrors.email = "Please enter your email address.";
    } else {
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

      if (!emailRegex.test(formData.email.trim())) {
        newErrors.email = "Please enter a valid email address.";
      }
    }

    // ------------------------------------------
    // PHONE
    // ------------------------------------------

    if (!formData.phone.trim()) {
      newErrors.phone = "Please enter your 10-digit mobile number.";
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = "Phone number must contain digits only.";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Phone number must be exactly 10 digits.";
    } else if (!validateIndianPhone(formData.phone)) {
      newErrors.phone =
        "Please enter a valid Indian mobile number starting with 6, 7, 8 or 9.";
    }

    // ------------------------------------------
    // WHATSAPP
    // ------------------------------------------

    if (formData.whatsapp.trim()) {
      if (!/^\d+$/.test(formData.whatsapp)) {
        newErrors.whatsapp = "WhatsApp number must contain digits only.";
      } else if (formData.whatsapp.length !== 10) {
        newErrors.whatsapp = "WhatsApp number must be exactly 10 digits.";
      } else if (!validateIndianPhone(formData.whatsapp)) {
        newErrors.whatsapp = "Please enter a valid Indian WhatsApp number.";
      }
    }

    // ------------------------------------------
    // CITY
    // ------------------------------------------

    if (!formData.city.trim()) {
      newErrors.city = "Please enter your city.";
    }

    // ------------------------------------------
    // SPORT
    // ------------------------------------------

    if (!formData.sport) {
      newErrors.sport = "Please select a sport or facility.";
    }

    // ------------------------------------------
    // MESSAGE
    // ------------------------------------------

    if (!formData.message.trim()) {
      newErrors.message = "Please describe your project requirements.";
    } else if (formData.message.trim().length < 10) {
      newErrors.message =
        "Please provide a little more information about your project.";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // ==========================================
  // SUBMIT QUOTE
  // ==========================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");
    setSuccess(false);

    // Validate BEFORE Firebase submission
    const isValid = validateForm();

    if (!isValid) {
      setError("Please correct the highlighted fields before submitting.");
      return;
    }

    try {
      setSubmitting(true);

      await addDoc(collection(db, "quoteRequests"), {
        ...formData,

        status: "New",

        source: "Website",

        createdAt: serverTimestamp(),

        updatedAt: serverTimestamp(),
      });

      setSuccess(true);

      setErrors({});

      setFormData(initialFormData);

      // Scroll to success message
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } catch (submitError) {
      console.error("Error submitting quote request:", submitError);

      setError("Unable to submit your request. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="contact-page">
      {/* ==========================================
          HERO
      ========================================== */}

      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>

        <div className="contact-hero-content">
          <span className="contact-badge">GET IN TOUCH</span>

          <h1>
            Let's Build Your
            <span> Sports Facility</span>
          </h1>

          <p>
            Tell us about your project and our team will get back to you with
            the right solution for your sports facility.
          </p>
        </div>
      </section>

      {/* ==========================================
          CONTACT INFORMATION + FORM
      ========================================== */}

      <section className="quote-section">
        <div className="quote-container">
          {/* ========================================
              LEFT SIDE
          ======================================== */}

          <div className="quote-info">
            <span className="section-label">GET A FREE QUOTE</span>

            <h2>
              Tell Us About
              <span> Your Project</span>
            </h2>

            <p className="quote-intro">
              Whether you are planning a new sports facility, renovating an
              existing court, or looking for premium sports flooring, our team
              is ready to help.
            </p>

            {/* CONTACT CARDS */}

            <div className="contact-info-list">
              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <FaPhoneAlt />
                </div>

                <div>
                  <small>Call Us</small>

                  <a href="tel:+919533634708">+91 95336 34708</a>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <FaWhatsapp />
                </div>

                <div>
                  <small>WhatsApp</small>

                  <a
                    href="https://wa.me/919533634708"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Chat With Us
                  </a>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <FaEnvelope />
                </div>

                <div>
                  <small>Email</small>

                  <a href="mailto:info@qualitysportssurface.com">
                    info@qualitysportssurface.com
                  </a>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <FaMapMarkerAlt />
                </div>

                <div>
                  <small>Location</small>

                  <span>India</span>
                </div>
              </div>

              <div className="contact-info-card">
                <div className="contact-info-icon">
                  <FaClock />
                </div>

                <div>
                  <small>Working Hours</small>

                  <span>Monday - Saturday</span>

                  <span>9:00 AM - 6:00 PM</span>
                </div>
              </div>
            </div>

            {/* TRUST MESSAGE */}

            <div className="quote-trust">
              <FaCheckCircle />

              <div>
                <strong>No obligation quote</strong>

                <p>
                  Our team will understand your requirements before recommending
                  the right solution.
                </p>
              </div>
            </div>
          </div>

          {/* ========================================
              RIGHT SIDE FORM
          ======================================== */}

          <div className="quote-form-wrapper">
            <div className="quote-form-header">
              <h3>Request A Free Quote</h3>

              <p>Fill in your project details below.</p>
            </div>

            {/* SUCCESS */}

            {success && (
              <div className="quote-success" role="alert">
                <FaCheckCircle />

                <div>
                  <strong>Request Submitted Successfully!</strong>

                  <p>
                    Thank you for contacting us. Our team will contact you
                    shortly.
                  </p>
                </div>
              </div>
            )}

            {/* ERROR */}

            {error && (
              <div className="quote-error" role="alert">
                {error}
              </div>
            )}

            <form className="quote-form" onSubmit={handleSubmit} noValidate>
              {/* ==================================
                  CUSTOMER INFORMATION
              ================================== */}

              <div className="form-section-title">Customer Information</div>

              <div className="form-grid">
                {/* FULL NAME */}

                <div className="form-group">
                  <label htmlFor="fullName">Full Name *</label>

                  <input
                    id="fullName"
                    type="text"
                    name="fullName"
                    placeholder="Enter your full name"
                    value={formData.fullName}
                    onChange={handleChange}
                    autoComplete="name"
                    className={errors.fullName ? "input-error" : ""}
                  />

                  {errors.fullName && (
                    <small className="field-error">{errors.fullName}</small>
                  )}
                </div>

                {/* COMPANY */}

                <div className="form-group">
                  <label htmlFor="company">Company / Organization</label>

                  <input
                    id="company"
                    type="text"
                    name="company"
                    placeholder="Company name"
                    value={formData.company}
                    onChange={handleChange}
                    autoComplete="organization"
                  />
                </div>

                {/* EMAIL */}

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>

                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    autoComplete="email"
                    className={errors.email ? "input-error" : ""}
                  />

                  {errors.email && (
                    <small className="field-error">{errors.email}</small>
                  )}
                </div>

                {/* PHONE */}

                <div className="form-group">
                  <label htmlFor="phone">Phone Number *</label>

                  <input
                    id="phone"
                    type="tel"
                    name="phone"
                    placeholder="Enter 10-digit mobile number"
                    value={formData.phone}
                    onChange={handleChange}
                    inputMode="numeric"
                    autoComplete="tel"
                    maxLength={10}
                    className={errors.phone ? "input-error" : ""}
                  />

                  {errors.phone && (
                    <small className="field-error">{errors.phone}</small>
                  )}

                  {!errors.phone && formData.phone.length === 10 && (
                    <small className="field-success">
                      ✓ Valid mobile number
                    </small>
                  )}
                </div>

                {/* WHATSAPP */}

                <div className="form-group">
                  <label htmlFor="whatsapp">WhatsApp Number</label>

                  <input
                    id="whatsapp"
                    type="tel"
                    name="whatsapp"
                    placeholder="Enter 10-digit WhatsApp number"
                    value={formData.whatsapp}
                    onChange={handleChange}
                    inputMode="numeric"
                    autoComplete="tel"
                    maxLength={10}
                    className={errors.whatsapp ? "input-error" : ""}
                  />

                  {errors.whatsapp && (
                    <small className="field-error">{errors.whatsapp}</small>
                  )}

                  {!errors.whatsapp && formData.whatsapp.length === 10 && (
                    <small className="field-success">
                      ✓ Valid WhatsApp number
                    </small>
                  )}
                </div>

                {/* CITY */}

                <div className="form-group">
                  <label htmlFor="city">City *</label>

                  <input
                    id="city"
                    type="text"
                    name="city"
                    placeholder="Your city"
                    value={formData.city}
                    onChange={handleChange}
                    autoComplete="address-level2"
                    className={errors.city ? "input-error" : ""}
                  />

                  {errors.city && (
                    <small className="field-error">{errors.city}</small>
                  )}
                </div>

                {/* STATE */}

                <div className="form-group">
                  <label htmlFor="state">State</label>

                  <input
                    id="state"
                    type="text"
                    name="state"
                    placeholder="Your state"
                    value={formData.state}
                    onChange={handleChange}
                    autoComplete="address-level1"
                  />
                </div>
              </div>

              {/* ==================================
                  PROJECT INFORMATION
              ================================== */}

              <div className="form-section-title">Project Information</div>

              <div className="form-grid">
                {/* SPORT */}

                <div className="form-group">
                  <label htmlFor="sport">Sport / Facility *</label>

                  <select
                    id="sport"
                    name="sport"
                    value={formData.sport}
                    onChange={handleChange}
                    className={errors.sport ? "input-error" : ""}
                  >
                    <option value="">Select Sport / Facility</option>

                    <option value="Basketball">Basketball Court</option>

                    <option value="Tennis">Tennis Court</option>

                    <option value="Football">Football Field</option>

                    <option value="Pickleball">Pickleball Court</option>

                    <option value="Badminton">Badminton Court</option>

                    <option value="Volleyball">Volleyball Court</option>

                    <option value="Cricket">Cricket / Box Cricket</option>

                    <option value="Squash">Squash Court</option>

                    <option value="Running Track">Running Track</option>

                    <option value="Synthetic Turf">Synthetic Turf</option>

                    <option value="EPDM Flooring">EPDM Flooring</option>

                    <option value="Multi Purpose">
                      Multi-Purpose Facility
                    </option>

                    <option value="Other">Other</option>
                  </select>

                  {errors.sport && (
                    <small className="field-error">{errors.sport}</small>
                  )}
                </div>

                {/* PROJECT TYPE */}

                <div className="form-group">
                  <label htmlFor="projectType">Project Type</label>

                  <select
                    id="projectType"
                    name="projectType"
                    value={formData.projectType}
                    onChange={handleChange}
                  >
                    <option value="">Select Project Type</option>

                    <option value="New Construction">New Construction</option>

                    <option value="Renovation">Renovation</option>

                    <option value="Resurfacing">Resurfacing</option>

                    <option value="Maintenance">Maintenance</option>

                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* DIMENSIONS */}

                <div className="form-group">
                  <label htmlFor="dimensions">Dimensions</label>

                  <input
                    id="dimensions"
                    type="text"
                    name="dimensions"
                    placeholder="Example: 100 ft × 50 ft"
                    value={formData.dimensions}
                    onChange={handleChange}
                  />
                </div>

                {/* AREA */}

                <div className="form-group">
                  <label htmlFor="area">Approximate Area</label>

                  <input
                    id="area"
                    type="text"
                    name="area"
                    placeholder="Example: 5000 sq.ft"
                    value={formData.area}
                    onChange={handleChange}
                  />
                </div>

                {/* SURFACE */}

                <div className="form-group">
                  <label htmlFor="surface">Surface / Flooring</label>

                  <select
                    id="surface"
                    name="surface"
                    value={formData.surface}
                    onChange={handleChange}
                  >
                    <option value="">Select Surface</option>

                    <option value="Acrylic">Acrylic</option>

                    <option value="PU">PU</option>

                    <option value="EPDM">EPDM</option>

                    <option value="Synthetic Turf">Synthetic Turf</option>

                    <option value="Rubber">Rubber</option>

                    <option value="Other">Other</option>
                  </select>
                </div>

                {/* BUDGET */}

                <div className="form-group">
                  <label htmlFor="budget">Budget Range</label>

                  <select
                    id="budget"
                    name="budget"
                    value={formData.budget}
                    onChange={handleChange}
                  >
                    <option value="">Select Budget</option>

                    <option value="Below 5 Lakh">Below ₹5 Lakh</option>

                    <option value="5 - 10 Lakh">₹5 - ₹10 Lakh</option>

                    <option value="10 - 25 Lakh">₹10 - ₹25 Lakh</option>

                    <option value="25 - 50 Lakh">₹25 - ₹50 Lakh</option>

                    <option value="50 Lakh+">₹50 Lakh+</option>

                    <option value="Not Decided">Not Decided</option>
                  </select>
                </div>

                {/* TIMELINE */}

                <div className="form-group">
                  <label htmlFor="timeline">Expected Timeline</label>

                  <select
                    id="timeline"
                    name="timeline"
                    value={formData.timeline}
                    onChange={handleChange}
                  >
                    <option value="">Select Timeline</option>

                    <option value="Immediately">Immediately</option>

                    <option value="Within 1 Month">Within 1 Month</option>

                    <option value="1 - 3 Months">1 - 3 Months</option>

                    <option value="3 - 6 Months">3 - 6 Months</option>

                    <option value="6+ Months">6+ Months</option>
                  </select>
                </div>
              </div>

              {/* ==================================
                  MESSAGE
              ================================== */}

              <div className="form-section-title">Project Requirements</div>

              <div className="form-group full-width">
                <label htmlFor="message">Tell Us About Your Project *</label>

                <textarea
                  id="message"
                  name="message"
                  rows="6"
                  placeholder="Describe your project, requirements, location, preferred materials, or anything else we should know..."
                  value={formData.message}
                  onChange={handleChange}
                  className={errors.message ? "input-error" : ""}
                />

                {errors.message && (
                  <small className="field-error">{errors.message}</small>
                )}
              </div>

              {/* ==================================
                  SUBMIT
              ================================== */}

              <button
                type="submit"
                className="quote-submit-btn"
                disabled={submitting}
              >
                {submitting ? "Submitting Request..." : "Submit Quote Request"}
              </button>

              <p className="form-note">
                By submitting this form, you agree that our team may contact you
                regarding your project enquiry.
              </p>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
